import { render, staticRenderFns } from "./HealStag.vue?vue&type=template&id=a3bcd43e"
import script from "./HealStag.vue?vue&type=script&lang=js"
export * from "./HealStag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports